(function () {
  var COMPANY_ID = window.KLAVIYO_COMPANY_ID;
  if (!COMPANY_ID) return;

  var SCRIPT_SRC = "https://static.klaviyo.com/onsite/js/" + COMPANY_ID + "/klaviyo.js";
  var AUTO_START_DELAY_MS = 20000;

  var state = (window.__klaviyoOnsiteState__ = window.__klaviyoOnsiteState__ || {
    inited: false,
    loaded: false,
    promise: null,
    started: false
  });

  function initKlaviyoStubOnce() {
    if (state.inited) return;
    state.inited = true;
    if (window.klaviyo) return;

    window._klOnsite = window._klOnsite || [];
    try {
      window.klaviyo = new Proxy({}, {
        get: function (_, method) {
          if (method === "push") {
            return function () {
              window._klOnsite.push.apply(window._klOnsite, arguments);
            };
          }
          return function () {
            var args = Array.prototype.slice.call(arguments);
            var cb = typeof args[args.length - 1] === "function" ? args.pop() : undefined;
            return new Promise(function (resolve) {
              window._klOnsite.push([method].concat(args, [function (res) {
                if (cb) cb(res);
                resolve(res);
              }]));
            });
          };
        }
      });
    } catch (e) {
      window.klaviyo = window.klaviyo || [];
      window.klaviyo.push = function () {
        window._klOnsite.push.apply(window._klOnsite, arguments);
      };
    }
  }

  function loadScriptOnce() {
    initKlaviyoStubOnce();
    if (state.loaded) return Promise.resolve();
    if (state.promise) return state.promise;

    if (document.querySelector('script[src^="https://static.klaviyo.com/onsite/js/"]')) {
      state.loaded = true;
      return Promise.resolve();
    }

    state.promise = new Promise(function (resolve, reject) {
      var s = document.createElement("script");
      s.src = SCRIPT_SRC;
      s.async = true;
      s.onload = function () { state.loaded = true; resolve(); };
      s.onerror = function (e) { state.promise = null; reject(e); };
      document.head.appendChild(s);
    });

    return state.promise;
  }

  function startKlaviyoOnsite() {
    if (state.started) return state.promise || Promise.resolve();
    state.started = true;
    return loadScriptOnce().catch(function (e) {
      console.warn("Klaviyo onsite failed to load", e);
    });
  }

  window.startKlaviyoOnsite = startKlaviyoOnsite;

  initKlaviyoStubOnce();
  if (window.KLAVIYO_CUSTOMER_EMAIL) {
    window.klaviyo.identify({ $email: window.KLAVIYO_CUSTOMER_EMAIL });
  }

  var fired = false;
  var events = ["pointerdown", "touchstart", "keydown", "wheel"];
  var opts = { passive: true };

  function onFirst() {
    if (fired) return;
    fired = true;
    events.forEach(function (ev) { window.removeEventListener(ev, onFirst, opts); });
    startKlaviyoOnsite();
  }

  events.forEach(function (ev) { window.addEventListener(ev, onFirst, opts); });

  if (AUTO_START_DELAY_MS > 0) {
    if (document.readyState === "complete") {
      setTimeout(startKlaviyoOnsite, AUTO_START_DELAY_MS);
    } else {
      window.addEventListener("load", function () {
        setTimeout(startKlaviyoOnsite, AUTO_START_DELAY_MS);
      }, { once: true });
    }
  }
})();